import React, { useEffect } from 'react';

import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

import { errorPageRendered } from '~/acquisition/actions';
import DefaultHead from '~/layout/components/DefaultHead';
import { isSavage } from '~/shared/utils/brandNameHelper';
import NotFound from '~/staticPages/components/NotFound';
import NotFoundSavage from '~/staticPages/components/NotFoundSavage';

const Wrapper = styled.div``;

export default function NotFoundPage() {
  const router = useRouter();
  const dispatch = useDispatch();

  // We'll force a 404 status code here, similar to _error.js
  useEffect(() => {
    // Next.js does not handle the error page throwing its own errors very
    // gracefully, causing an infinite loop, so prevent that here.
    try {
      dispatch(errorPageRendered(router.asPath, 404));
    } catch (err) {
      // Whelp, we tried.
    }
  }, [dispatch, router]);

  return (
    <Wrapper>
      <DefaultHead />
      {isSavage() ? <NotFoundSavage /> : <NotFound />}
    </Wrapper>
  );
}
